<template>
  <div class="excelImport">
    <div class="row">
      <div  class="col-md-6">
        <div class="header">
          <h5>Select Channels from the list</h5>
        </div>
          <div 
            class="bordered-box"
            style="text-align: center; cursor: pointer"
            @click="$emit('request-type', false)"
          >
            <font-awesome-icon
              :icon="['fas', 'list']"
              style="font-size: 96px; color: gray"
            />
          </div>
      </div>
      <div class="col-md-6">
        <div class="header">
          <h5>Import Channels To Decommission</h5>
        </div>
        <div 
          class="bordered-box"
          style="text-align: center; cursor: pointer"
        >
          <font-awesome-icon
            :icon="['far', 'cloud-arrow-up']"
            style="font-size: 96px; color: gray"
            class="pointer"
            @click="showFileUploader()"
          />
          <div class="row" >
            <div style="padding-left:60px">
              <a
                target="_blank"
                href="/static-contents/ChannelDecommissionTemplate.xlsx"
              >
                <span>
                  <font-awesome-icon
                    :icon="['far', 'cloud-arrow-down']"
                    style="font-size: 16px; color: gray"
                  />
                </span>
                <span style="padding-left:5px">Download Template</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="padding-bottom">
        <input
          type="file"
          id="channelUploadInputControl"
          class="hidden"
          onclick="this.value=null;"
        />
      </div>
    </div>
    <!-- ExcelColumnMapper Popup starts-->
    <div>
      <customModal
        id="excelColMapperModalContainer"
        title="Match Uploaded Columns to our Data"
        :show.sync="showExcelMapper"
        :centered="true"
        :backdrop="true"
        :closeOnBackdrop="false"
        width="35%"
        :CCRColoBrand="true"
      >
        <ExcelColumnMapper
          v-if="showExcelMapper"
          @hide-modal="showExcelMapper = false"
          :CustomExcelColumn="CustomExcelColumn"
          @set-excel-columns="setExcelCustomColumns"
        />
      </customModal>
    </div>
    <!-- ExcelColumnMapper Popup ends-->
    <DxLoadPanel
      :position="loaderPosition"
      :visible.sync="loaderVisible"
      :show-indicator="true"
    />
  </div>
</template>
<script>
import { DxLoadPanel } from "devextreme-vue/load-panel";
import readXlsxFile from "read-excel-file";
import notify from "devextreme/ui/notify";
import ExcelColumnMapper from "../../../views/channelsDecommissionRequest/ExcelColumnMapper.vue";
export default {
  name: "RequestType",
  components: {
    DxLoadPanel,
    ExcelColumnMapper
  },
  data() {
    return {
      loaderPosition: { of: ".excelImport" },
      loaderVisible: false,
      importedExcelData: [],
      rawExcelData: [],
      CustomExcelColumn: [],
      showExcelMapper: false,
      defaultColumns: ["ProductInstanceID", "DecommissionDate"],
      ExcelIndex: {
        ProductInstanceID: 0,
        DecommissionDate: 1,
      },
    };
  },
  mounted: function () {
    let th = this;
    let input = document.getElementById("channelUploadInputControl");
    input.addEventListener("change", () => {
      th.loaderVisible = true;
      readXlsxFile(input.files[0]).then((rows) => {
        th.importedExcelData = [];
        th.rawExcelData = [];
        th.rawExcelData = rows;
        th.checkCustomColumns(rows);
        th.loaderVisible = false;
      });
    });
  },
  methods: {
    showFileUploader() {
      document.getElementById("channelUploadInputControl").click();
    },
    checkCustomColumns(rows) {
      let th = this;
      // if (JSON.stringify(rows[0]) != JSON.stringify(this.defaultColumns)) {
      //   notify(
      //     {
      //       message: "Not valid",
      //       position: {
      //         my: "center top",
      //         at: "center top",
      //       },
      //       width: "300px",
      //     },
      //     "error",
      //     5000
      //   );
      //   return;
      // } else {
      // If not default CCR template ,show columns mapper modal
        if (JSON.stringify(rows[0]) != JSON.stringify(this.defaultColumns)) {
          this.CustomExcelColumn = rows[0];
          this.showExcelMapper = true;
        } else {
          //process data
          th.processExcelData(rows, 1);
        }
    },
    processExcelData(array, startRowDataIndex) {
      let th = this;
      this.loaderVisible = true;
      let temp = [];
      if (array.length > 0) {
        array.slice(startRowDataIndex).forEach((rowData, k) => {
          if (!rowData[k]) rowData[k] = null;
          let jsonObj = {};
          jsonObj = {
            //RowID: k + 1, Unique ID for row
            ProductInstanceID:
              th.ExcelIndex.ProductInstanceID != undefined
                ? rowData[th.ExcelIndex.ProductInstanceID]
                : null,
            RequestedDate:
              th.ExcelIndex.DecommissionDate != undefined
                ? rowData[th.ExcelIndex.DecommissionDate]
                : null,
          };
          th.importedExcelData.push(jsonObj);
          temp.push(k);
          if (temp.length === array.length - 1) {
            th.$emit("set-Channel-Decommission", th.importedExcelData);
            th.loaderVisible = false;
            th.$emit("show-next-step");
            th.$emit("request-type",true);
          }
        });
      }
    },
    setExcelCustomColumns(excelIndex) {
      let th = this;
      this.ExcelIndex = {};
      this.ExcelIndex = excelIndex;
        th.processExcelData(th.rawExcelData, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.hidden {
  display: none;
}
.header {
  color: #fff;
  background-color: #636466;
  height: 30px;
  width: 280px;
  padding: 5px 10px;
  border-bottom: none;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  box-sizing: border-box;

  h5 {
    font-size: 16px;
  }
}
.bordered-box {
  border: 1px solid #ddd;
  padding: 15px 10px;
  color: #333333;
  border-radius: 0px 0px 5px 5px;
  height: 150px;
  width: 280px;
  text-align: center;
  cursor: pointer;
}
.excelImport {
  padding: 4%;
  padding-left: 15%;
}
</style>